import swal from "sweetalert2";
import AdminApi from "../../services/api";
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";
import {integer} from "vee-validate/dist/rules.esm";


const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            role: '',
            locale: LocService,
            notifications: [],
            showNoNotification: false,
            showNotification: false,
            showDialogApp: false
        }
    },
    methods: {
        getNotifications: getNotifications,
        deleteNotification: deleteNotification,
        getStyle: getStyle,
        getConfig: getConfig,
        isLink: isLink,
        detectAgent: detectAgent,
        displayDate: displayDate,
        close: close,
        getText: getText,
        getMonthDisplay: getMonthDisplay,
        isSimpleText: isSimpleText,
        onButtonClicked: onButtonClicked,
        getButtonText: getButtonText,
        isButton: isButton,
        isLoggedIn() {
            return session.getAccessToken() !== null && session.getAccessToken().length > 0
        },
        loadUser() {
            if(localStorage.getItem('ACCESS_TOKEN') == null) return;
            AdminApiService.getProfile()
                .then((response) => {
                })
                .catch(error => {
                    swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
                })
        },
        openTerms:openTerms
    },
    beforeMount() {
        this.$router.push('/home-page');
        return;
        // this.role = session.getRole();
        // this.getNotifications()
        // this.detectAgent()
        // this.getConfig();
        // if(!this.isLoggedIn()){
        //     this.$router.push('/login');
        //     return;
        // }
        // this.loadUser()
    }
}


function getConfig(){
    if(!session.shouldFetchConfig()) {
        this.showNotification = session.getConfig().showNotificationOnHome
        this.showDialogApp = session.getConfig().shouldAskToDownloadApps
        this.getNotifications()
        this.detectAgent()
        return;
    }
    let _self = this;
    AdminApiService.getCompanyConfiguration(CONFIG_COMPANY.NAME)
        .then((response) => {
            session.saveConfig(response.data)
            session.setLastFetchConfig();
            _self.showNotification = session.getConfig().showNotificationOnHome
            _self.showDialogApp = session.getConfig().shouldAskToDownloadApps
            _self.getNotifications()
            _self.detectAgent()
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function detectAgent() {
    if(!this.showDialogApp) return;
    let androidUrl = session.getConfig().googlePlay;
    let aAndroid = '<a href=\"' + androidUrl +'\">';
    let iosUrl = session.getConfig().appStore;
    let aios = '<a href=\"' + iosUrl +'\">';
    if(navigator.userAgent.toString().includes("Android")){
        swal({
            title: LocService.t("label_download_app"),
            html : '<html><div class="foo">' +
                '<br>' +
                aAndroid +
                '<div class="dialog-google-play"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: LocService.t("label_not_now"),
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }else if(navigator.userAgent.toString().includes("iPhone")){
        swal({
            title: LocService.t("label_download_app"),
            html : '<html><div class="foo">' +
                '<br>' +
                aios +
                '<div class="dialog-app-store"></div>'+
                '</a>' +
                '<br>'+
                // '<a><u>Ne sada</u></a>'+
                '</div></html>',
            text: "",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: LocService.t("label_not_now"),
            customClass: 'swal2-warning'
        }).then(function () {

        });
    }
}

function close() {
    swal.close()
}

function getNotifications() {
    let _self = this;
    this.showNoNotification = false;
    AdminApiService.getNotification(CONFIG_COMPANY.NAME)
        .then((response) => {
            _self.notifications = response.data
            _self.showNoNotification = _self.notifications.length === 0;
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getStyle(notification) {
    if(notification.priority === 'LOW'){
        return "background-color: #7CB450;"
    }else if(notification.priority === 'MEDIUM'){
        return "background-color: #C9BE5B;"
    } else if(notification.priority === 'HIGH'){
        return "background-color: #D06B6B;"
    }
}

function deleteNotification(notification) {
    let _self = this;
    swal({
        title: LocService.t("label_are_you_sure"),
        text: LocService.t("label_are_you_sure_delete_notification"),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t("label_yes"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t("label_yes"),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteNotifications(notification.id)
            .then((response) => {
                _self.getNotifications()
                swal(LocService.t("label_success"),LocService.t("label_success_delete_notification"), 'success')
            })
            .catch(error => {
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });



}

function isLink(text) {
    return (text.includes('http') || text.includes('www')) && !text.includes('<-dugme->')
}

function isSimpleText(text) {
    return !text.includes('http') && !text.includes('www') && !text.includes('<-dugme->')
}

function isButton(text) {
    return text.includes('<-dugme->')
}

function onButtonClicked(text) {
    let temp = text.split('<-dugme->')[1]
    window.open(temp, "_blank");
}

function getButtonText(text) {
    return text.split('<-dugme->')[0]
}

function openTerms(){
    this.$router.push('/terms');
}


function displayDate(timestamp){
    let date = this.$moment(new Date(timestamp)).format('DD-MM')
    let temp = date.split("-")
    return {
        day: parseInt(temp[0]).toString(),
        month: this.getMonthDisplay(temp[1])
    }
}

function getMonthDisplay(month) {
    switch (month) {
        case '01': return this.locale.t("month_short_january");
        case '02': return this.locale.t("month_short_february");
        case '03': return this.locale.t("month_short_march");
        case '04': return this.locale.t("month_short_april");
        case '05': return this.locale.t("month_short_may");
        case '06': return this.locale.t("month_short_june");
        case '07': return this.locale.t("month_short_july");
        case '08': return this.locale.t("month_short_august");
        case '09': return this.locale.t("month_short_september");
        case '10': return this.locale.t("month_short_october");
        case '11': return this.locale.t("month_short_november");
        case '12': return this.locale.t("month_short_december");
        default: return this.locale.t("month_short_january");
    }
}

function getText(item){
    if(session.getLocale() === 'sr'){
        return item.text;
    }else if(item.enText != null && item.enText.length > 0){
        return  item.enText;
    }
    return item.text;
}



// WEBPACK FOOTER //
// ./src/components/Home/HomeFiskultura.js